import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=1577319c&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"
import style0 from "./Quotations.vue?vue&type=style&index=0&id=1577319c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577319c",
  null
  
)

export default component.exports